import { CoreIcon } from '../core-icon';
import couponFillSVG from '../../../src/images/icons/coupon-fill.svg';

export const CouponFillIcon = props => {
  return <CoreIcon src={couponFillSVG} {...props} />;
};
